import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import NumberInput from '../../common/controls/numberInput';
import SegmentedPicker from '../../common/controls/segmentedPicker';
const ContractSpecAmbientConditions = ({
  onChange,
  active
}) => {
  const handleChangeTempUnits = value => onChange('tempUnits', value);
  const handleChangeAirTempMin = value => onChange('airTempMin', value);
  const handleChangeAirTempMax = value => onChange('airTempMax', value);
  const handleChangeWetBulbTempMin = value => onChange('wetBulbTempMin', value);
  const handleChangeWetBulbTempMax = value => onChange('wetBulbTempMax', value);
  const handleChangeRelativeHumidityMin = value => onChange('relativeHumidityMin', value);
  const handleChangeRelativeHumidityMax = value => onChange('relativeHumidityMax', value);
  const handleChangeDewPointTempMin = value => onChange('dewPointTempMin', value);
  const handleChangeDewPointTempMax = value => onChange('dewPointTempMax', value);
  const handleChangeSurfaceTempMin = value => onChange('surfaceTempMin', value);
  const handleChangeSurfaceTempMax = value => onChange('surfaceTempMax', value);
  const handleChangeDeltaTempMin = value => onChange('deltaTempMin', value);
  const handleChangeDeltaTempMax = value => onChange('deltaTempMax', value);
  return /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "Ambient Conditions"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['°F', '°C'],
    values: [0, 1],
    label: "Temp Units",
    allowNull: false,
    onChange: handleChangeTempUnits,
    value: active.tempUnits
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Air Temp"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: active.airTempMin,
    entity: "ContractSpec",
    field: "airTempMin",
    onChange: handleChangeAirTempMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: active.airTempMax,
    entity: "ContractSpec",
    field: "airTempMax",
    onChange: handleChangeAirTempMax
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Wet Bulb Temp"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: active.wetBulbTempMin,
    entity: "ContractSpec",
    field: "wetBulbTempMin",
    onChange: handleChangeWetBulbTempMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: active.wetBulbTempMax,
    entity: "ContractSpec",
    field: "wetBulbTempMax",
    onChange: handleChangeWetBulbTempMax
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Relative Humidity"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: active.relativeHumidityMin,
    entity: "ContractSpec",
    field: "relativeHumidityMin",
    onChange: handleChangeRelativeHumidityMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: active.relativeHumidityMax,
    entity: "ContractSpec",
    field: "relativeHumidityMax",
    onChange: handleChangeRelativeHumidityMax
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Dew Point"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: active.dewPointTempMin,
    entity: "ContractSpec",
    field: "dewPointTempMin",
    onChange: handleChangeDewPointTempMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: active.dewPointTempMax,
    entity: "ContractSpec",
    field: "dewPointTempMax",
    onChange: handleChangeDewPointTempMax
  }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Surface Temp"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: active.surfaceTempMin,
    entity: "ContractSpec",
    field: "surfaceTempMin",
    onChange: handleChangeSurfaceTempMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: active.surfaceTempMax,
    entity: "ContractSpec",
    field: "surfaceTempMax",
    onChange: handleChangeSurfaceTempMax
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h5", {
    className: "text-input-custom-label"
  }, "Delta"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Min",
    value: active.deltaTempMin,
    entity: "ContractSpec",
    field: "deltaTempMin",
    onChange: handleChangeDeltaTempMin
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(NumberInput, {
    placeholder: "Max",
    value: active.deltaTempMax,
    entity: "ContractSpec",
    field: "deltaTempMax",
    onChange: handleChangeDeltaTempMax
  }))))));
};
ContractSpecAmbientConditions.propTypes = {
  active: PropTypes.shape({
    tempUnits: PropTypes.number,
    airTempMax: PropTypes.number,
    airTempMin: PropTypes.number,
    deltaTempMax: PropTypes.number,
    deltaTempMin: PropTypes.number,
    wetBulbTempMax: PropTypes.number,
    wetBulbTempMin: PropTypes.number,
    surfaceTempMax: PropTypes.number,
    surfaceTempMin: PropTypes.number,
    relativeHumidityMax: PropTypes.number,
    relativeHumidityMin: PropTypes.number,
    dewPointTempMax: PropTypes.number,
    dewPointTempMin: PropTypes.number
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
export default ContractSpecAmbientConditions;